module.exports = __webpack_public_path__ + "img/entertainment-rugs-runners.8b3d19a.jpg";